module.exports = __webpack_public_path__ + "img/PPalintoon64_ua.41b61287.webp";